import { relations } from 'drizzle-orm';
import { dataDeletionRequests } from '../models/dataDeletionRequests';

/**
 * @group User
 * @summary Data deletion request relations for the database schema
 *
 * @remarks
 * The DataDeletionRequests table intentionally has no foreign key relations to
 * Users or PatientProfiles. This is by design: deletion requests must persist
 * even after user data is deleted, for audit trail purposes. The email field
 * is used to look up users at confirmation time.
 *
 * @example
 * ```typescript
 * import { dataDeletionRequestRelations } from '@shared/db';
 *
 * // Query deletion request (no relations to expand)
 * const request = await db.query.dataDeletionRequests.findFirst({
 *   where: eq(dataDeletionRequests.token, token),
 * });
 * ```
 */
export const dataDeletionRequestRelations = relations(dataDeletionRequests, () => ({
  // No foreign key relations by design - see remarks
}));
